import { billingApi } from "../api/billingApi";
import { getToken } from "../utils/getToken";

export interface CreditCardInfo {
  email: string;
  isCreditCardAvailable: boolean;
}

export const billingService = {
  getCreditCard: async (): Promise<CreditCardInfo[] | null> => {
    const token = getToken();
    if (!token) return null;

    try {
      const response = await billingApi.getCreditCards(token);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch credit cards:", error);
      return null;
    }
  },
  payTargetMarketing: async (
    currency: string,
    totalAmount: number,
    brandId: string,
    brandName: string,
  ): Promise<any> => {
    const token = getToken();
    if (!token) return null;

    const payload = {
      currency,
      total_amount: totalAmount,
      brand_id: brandId,
      brand_name: brandName,
    };

    try {
      const response = await billingApi.payTargetMarketing(token, payload);

      return response;
    } catch (error) {
      console.error("Failed to pay target marketing:", error);
      return null;
    }
  },
};
